import {DICT_KEY, getDictNameByCode, getModel, setModel} from "../../../utils/constants";
import ModelUtils from "../../../utils/ModelUtils";
import StockCheckService from "./StockCheckService";
import StockStatisticService from "../statistic/StockStatisticService";
import moment from "moment";
import {v4 as uuidv4} from "uuid"

const MODEL_KEY = DICT_KEY.STOCK_CHECK;
const storageModel = getModel(MODEL_KEY);

//转换日期函数
function transRangePickerValue(obj, ...values) {
    if (!!!obj) return;
    let tmp = obj;
    for (let i = 0; i < values.length; i++) {
        if (tmp[values[i]]) {
            tmp = tmp[values[i]]
        } else {
            break;
        }
        if (i === values.length - 1) {
            tmp[0] = moment(tmp[0])
            tmp[1] = moment(tmp[1])
        }
    }
}

transRangePickerValue(storageModel, "searchParam", "checkTime");
const cacheAble = false;
const stockCheckModel = {
    state: cacheAble && storageModel ? storageModel : {
        //查询参数
        searchParam: {},
        //盘点查询列表
        checkList: [],
        //盘点查询列表->选中keys
        checkListSelectedRowKeys: [],
        //盘点分页数据
        checkPage: {
            total: 0,
            pageNum: 1,
            pageSize: 15
        },

        //盘点详情
        check: {},
        //盘点明细列表
        checkDetailList: [],
        //盘点明细列表->选中keys
        checkDetailListSelectedRowKeys: [],
        checkStatistic: {
            inventoryBook: 0,//账面库存量
            inventoryPhysical: 0,//实物盘点量
            differenceTotal: 0,//差异总量
            scrapTotal: 0,//报废总量
            differenceAmount: 0.00,
            scrapAmount: 0.00,
        },
        //库存数据选择窗口显示标志
        stockItemSelectModelVisible: false,
        //库存数据查询条件
        stockItemSearchParam: {},
        //库存查询列表
        stockItemList: [],
        //库存分页信息
        stockItemPage: {
            total: 0,
            pageNum: 1,
            pageSize: 5
        },
        //已选中库存列表
        selectedStockItemList: [],
    },

    reducers: {
        setCheckStatistic(state, payload) {
            state.checkStatistic = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setSearchParam(state, payload) {
            state.searchParam = {...state.searchParam, ...payload};
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        resetSearchParam(state,) {
            state.searchParam = {};
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setCheckList(state, payload) {
            state.checkList = payload;
        },
        setCheckListSelectedRowKeys(state, payload) {
            state.checkListSelectedRowKeys = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setCheckPage(state, payload) {
            state.checkPage = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setCheck(state, payload) {
            state.check = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setCheckDetailList(state, payload) {
            state.checkDetailList = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        removeCheckDetailList(state,) {
            state.checkDetailList = state.checkDetailList.filter(el => !!!state.checkDetailListSelectedRowKeys.find(ele => ele === el.key));
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        importCheckDetailList(state, payload) {
            // console.log(payload)
            const mappedList = payload.map(el => ({...el, key: uuidv4()}));
            state.checkDetailList = [...state.checkDetailList, ...mappedList]
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setCheckDetailListSelectedRowKeys(state, payload) {
            state.checkDetailListSelectedRowKeys = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setStockItemSelectModelVisible(state, payload) {
            state.stockItemSelectModelVisible = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setStockItemSearchParam(state, payload) {
            state.stockItemSearchParam = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setStockItemList(state, payload) {
            state.stockItemList = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setStockItemPage(state, payload) {
            state.stockItemPage = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setSelectedStockItemList(state, payload) {
            state.selectedStockItemList = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        //选中库存列表转化为盘点明细列表
        transSelectedStockItemListToStockItemList(state,) {
            const mappedItems = state.selectedStockItemList.map(stockItemMapToCheckItem)
            // console.log(mappedItems)
            state.checkDetailList = [...state.checkDetailList, ...mappedItems];
            // console.log(state.checkDetailList)
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },

        addToSelectedStockItemList(state, payload) {
            state.selectedStockItemList.push(payload);
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        removeFromSelectedStockItemList(state, payload) {
            state.selectedStockItemList = state.selectedStockItemList.filter(el => el.key !== payload.key)
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        updateStatus(state, status) {
            state.check = {...state.check, orderStatus: status}
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },

    },
    effects: () => ({
        //加载盘点列表
        async loadCheckList({showMsg = true, duration = 5, data}) {
            const funName = "加载盘点数据";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await StockCheckService.findPage(data);
                const {list, ...page} = retData;
                const mappedList = list.map(el => {
                    return {
                        key: el.id,
                        ...el,
                        orgName: el.orgId ? getDictNameByCode(DICT_KEY.CM_DICT.ORG, el.orgId, true) : "",
                        warehouseName: el.warehouseId ? getDictNameByCode(DICT_KEY.CM_DICT.WAREHOUSE, el.warehouseId) : "",
                        orderStatusName: el.orderStatus ? getDictNameByCode(DICT_KEY.CM_DICT.STOCK_CHECK_STATUS, el.orderStatus) : "",
                    }
                })
                // list.forEach(el => el.key = el.id);
                this.setCheckList(mappedList);
                this.setCheckPage(page);
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);

        },
        //加载特定盘点信息
        async loadCheck({showMsg = true, duration = 5, data}) {
            const funName = "加盘点信息";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await StockCheckService.findByIdOrCode(data);
                const {details, ...check} = retData;
                details.forEach(el => el.key = el.id);
                this.setCheckDetailList(details);
                this.setCheck(check);
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },

        //加载库存
        async loadStockItem({showMsg = true, duration = 5, data}) {
            const funName = "加载库存信息";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await StockStatisticService.findPage(data);
                const {list, ...page} = retData;
                const mappedList = list.map(el => {
                    return {
                        ...el,
                        // key: el.materialCode + "_" + el.shelfCode + "_" + el.inventoryNum,
                        key: el.id,
                        materialUnitName: getDictNameByCode(DICT_KEY.CM_DICT.MATERIAL_UNIT, el.materialUnit),
                        materialBrandName: getDictNameByCode(DICT_KEY.CM_DICT.BRAND, el.materialBrand),
                    }
                });
                this.setStockItemList(mappedList);
                this.setStockItemPage(page);
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },

        //新增盘点
        async insert({showMsg = true, duration = 5, data}) {
            const funName = "新增盘点";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await StockCheckService.insert(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },

        //修改盘点
        async update({showMsg = true, duration = 5, data}) {
            const funName = "修改盘点";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await StockCheckService.update(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //盘点作废
        async disable({showMsg = true, duration = 5, data}) {
            const funName = "盘点作废";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await StockCheckService.disable(data);
                if (retData) {
                    this.updateStatus("031003");
                }
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //盘点完成
        async finish({showMsg = true, duration = 5, data}) {
            const funName = "盘点完成";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await StockCheckService.finish(data);
                if (retData) {
                    this.updateStatus("031002");
                }
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //导出盘点列表
        async exportCheckList({showMsg = true, duration = 5, data}) {
            const funName = "导出盘点数据";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await StockCheckService.exportCheckList(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //导出盘库商品
        async exportDetail({showMsg = true, duration = 5, data}) {
            const funName = "导出盘点数据";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await StockCheckService.exportDetail(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //导入盘库明细(暂时不用)
        async importDetail({showMsg = true, duration = 5, data}) {
        }
    })
}

//库存数据转换为盘点明细数据
const stockItemMapToCheckItem = el => {
    const {
        key,
        id,
        materialId,
        materialCode,
        replaceNum,
        materialName,
        warehouseId,
        warehouseName,
        shelfId,
        shelfCode,
        inventoryNum,
        inventoryTotal,
        costPrice=0
    } = el;
    return {
        key,
        id,
        inventoryListCode: null,
        materialId,
        materialCode,
        replaceNum,
        materialName,
        warehouseId,
        warehouseName,
        shelfId,
        shelfCode,
        inventoryNum,
        checkNum: 0,
        differenceNum: 0,
        scrapNum: 0,
        detailsStatus: null,
        checkResult: (inventoryNum && parseInt(inventoryNum) > 0) ? -1 : 0,
        inventoryListDesc: "",
        averagePrice: costPrice,
    }
}
export default stockCheckModel;
